<nav class="flex items-center gap-2 text-sm">
  <a routerLink="/dashboard" class="text-gray-400 hover:text-primary transition-colors">
    <lucide-icon name="Home" [size]="16"></lucide-icon>
  </a>
  <ng-container *ngFor="let crumb of breadcrumbs; let last = last">
    <lucide-icon name="ChevronRight" [size]="14" class="text-gray-300"></lucide-icon>
    <a *ngIf="!last; else current"
       [routerLink]="crumb.url"
       class="text-gray-500 hover:text-primary transition-colors capitalize">
      {{ crumb.label }}
    </a>
    <ng-template #current>
      <span class="text-primary font-medium capitalize">{{ crumb.label }}</span>
    </ng-template>
  </ng-container>
</nav>
